import $ from 'cash-dom';

$(function () {
	const $showAccessibilityButton = $('#show-accessibility-button');
	let siennaPromise = null;
	let openingPromise = null;

	const getSiennaButton = () => $('.asw-container:not(#show-accessibility-button) .asw-widget .asw-menu-btn');

	const waitForSiennaButton = () => new Promise((resolve) => {
		const intervalId = setInterval(() => {
			const $accessibilityWidgetButton = getSiennaButton();

			if ($accessibilityWidgetButton.length) {
				$accessibilityWidgetButton.attr('data-btn-name', 'accessibility-widget');
				clearInterval(intervalId);
				resolve($accessibilityWidgetButton);
			}
		}, 50);
	});

	const ensureSiennaLoaded = () => {
		if (siennaPromise) {
			return siennaPromise;
		}

		siennaPromise = import('../../vendor/sienna.min').then(() => {
			// sienna initializes on `document.readystatechange`
			// if loaded after `load`, trigger it manually so the widget can mount.
			document.dispatchEvent(new Event('readystatechange'));

			return waitForSiennaButton();
		}).catch((error) => {
			siennaPromise = null;
			throw error;
		});

		return siennaPromise;
	};

	const openAccessibilityWidget = () => {
		if (openingPromise) {
			return openingPromise;
		}

		openingPromise = ensureSiennaLoaded().then(($accessibilityWidgetButton) => {
			$showAccessibilityButton.remove();
			$accessibilityWidgetButton.trigger('click');
		}).then(() => {
			openingPromise = null;
		}, () => {
			openingPromise = null;
		});

		return openingPromise;
	};

	if ($showAccessibilityButton.length) {
		$showAccessibilityButton.find('.asw-menu-btn').on('click', (e) => {
			e.preventDefault();

			openAccessibilityWidget();
		});
	}

	const $aswBtn2 = $('#asw_menu_btn2');
	if ($aswBtn2.length) {
		$aswBtn2.on('click', (e) => {
			e.preventDefault();

			$('.refine-button-box').hide();
			openAccessibilityWidget();
		});
	}
});
